var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import styled from "styled-components";
import breakpoints from "../../../theme/foundations/mediaQueries";
import { typographyBreakpoint, } from "../../../theme/foundations/typography";
import { PrimaryLink } from "../Link/styled";
var generateResponsiveStyles = function (theme, colors, textStyles) {
    var breakpointsStyles = new Map();
    var addBreakpointStyle = function (breakpoint, style) {
        if (breakpointsStyles.has(breakpoint)) {
            breakpointsStyles.set(breakpoint, __assign(__assign({}, breakpointsStyles.get(breakpoint)), style));
        }
        else {
            breakpointsStyles.set(breakpoint, style);
        }
    };
    Object.entries(colors || {}).forEach(function (_a) {
        var _b = __read(_a, 2), breakpoint = _b[0], color = _b[1];
        return addBreakpointStyle(breakpoint, { $color: color });
    });
    Object.entries(textStyles || {}).forEach(function (_a) {
        var _b = __read(_a, 2), breakpoint = _b[0], textStyle = _b[1];
        return addBreakpointStyle(breakpoint, {
            $textStyle: textStyle,
        });
    });
    var result = {};
    breakpointsStyles.forEach(function (_a, key) {
        var $color = _a.$color, $textStyle = _a.$textStyle;
        var color = $color ? theme.color[$color] : "fakeBlack";
        var typography = $textStyle ? theme.typography[$textStyle] : {};
        result["@media ".concat(breakpoints[key])] = __assign({ color: color }, typography);
    });
    return result;
};
var StyledText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  a {\n    text-decoration: underline;\n    ", "\n  }\n"], ["\n  ", "\n\n  a {\n    text-decoration: underline;\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme, $color = _a.$color, $align = _a.$align, _b = _a.$textStyle, $textStyle = _b === void 0 ? "subtitle1" : _b, _c = _a.$forceMobile, $forceMobile = _c === void 0 ? false : _c, $colors = _a.$colors, $textStyles = _a.$textStyles;
    var styles = {};
    if ($align)
        styles.textAlign = $align;
    styles.color = $color ? theme.color[$color] : "inherit";
    var responsiveStyles = generateResponsiveStyles(theme, $colors, $textStyles);
    return __assign(__assign(__assign(__assign({}, styles), theme.typography[$textStyle]), ($forceMobile
        ? theme.typography[$textStyle][typographyBreakpoint]
        : {})), responsiveStyles);
}, PrimaryLink);
export default StyledText;
var templateObject_1;
